import { createTheme } from "@mui/material";
import { colorPrimary, colorSecondary } from "../../theme";
import { mergeDeepRight } from "ramda";

export const createOrganizeTheme = outerTheme =>
  createTheme(mergeDeepRight(outerTheme, organizeTheme));

const defaultTheme = createTheme();

const organizeTheme = {
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&.Mui-expanded": {
            margin: 0,
          },
          "&::before, &.Mui-expanded::before": {
            opacity: 0,
          },
        },
      },
    },

    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: defaultTheme.spacing(3, 0),
          "&.Mui-expanded": {
            margin: defaultTheme.spacing(3, 0),
          },
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          fontSize: "1.6rem",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        endIcon: {
          color: colorPrimary.darker,
        },

        outlinedPrimary: {
          color: colorPrimary.brandPrimary,
          borderWidth: 2,
          borderColor: colorPrimary.brandPrimary,
          borderRadius: 30,
          textTransform: "none",
          fontSize: "1.4rem",
          lineHeight: "20px",
          fontWeight: 700,
          height: "36px",
          "&:hover": {
            borderWidth: 2,
            borderColor: colorPrimary.brandPrimary,
          },
        },

        text: {
          color: colorPrimary.darker,
          fontWeight: 400,
          fontSize: "1.4rem",
          lineHeight: "20px",
        },

        textPrimary: {
          color: colorPrimary.brandPrimary,
          fontWeight: 400,
          fontSize: "1.4rem",
          lineHeight: "20px",
        },

        textSizeLarge: {
          fontSize: "2rem",
          lineHeight: "28px",
          fontWeight: 700,
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          color: colorPrimary.darker,
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: colorPrimary.darker,
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: colorSecondary.light,
            color: "black",
            "& p": {
              color: "black",
            },
          },
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        h1: {
          fontWeight: 700,
          color: colorPrimary.darker,
          lineHeight: "28px",
          fontSize: "2rem",
        },

        h2: {
          fontWeight: 700,
          color: colorPrimary.darker,
          fontSize: "1.6rem",
          lineHeight: "24px",
        },
      },
    },
  },
};
